import { Controller, useFormContext } from "react-hook-form";
import {
	SelectArrow,
	SelectItem,
	SelectLabel,
	SelectPopover,
	SelectRoot,
	SelectTrigger,
	SelectValue,
} from "../Select/Select";
import { Translate } from "@/components/Translate";
import styles from "./SelectField.module.css";

type Option = {
	value: string;
	label: string;
};

type ControlledProps = {
	label: React.ReactNode;
	name: string;
	options: Option[];
	placeholder?: string;
};

type UncontrolledProps = {
	label: React.ReactNode;
	value: string;
	onChange: (val: string) => void;
	options: Option[];
	placeholder?: string;
};

type SelectFieldProps = ControlledProps | UncontrolledProps;

export const SelectField = (props: SelectFieldProps) => {
	const form = useFormContext();

	if ("name" in props && form) {
		// Controlled with react-hook-form
		const { name, label, options, placeholder } = props;

		return (
			<Controller
				name={name}
				control={form.control}
				render={({ field }) => (
					<div className={styles.root}>
						<SelectRoot
							value={field.value}
							setValue={(val) => {
								const selected = Array.isArray(val) ? val[0] : val;
								field.onChange(selected);
							}}
						>
							<SelectLabel>{label}</SelectLabel>
							<SelectTrigger>
								<SelectValue>
									{(value) => {
										const selected = options.find((o) => o.value === value);
										const displayLabel = selected?.label ?? placeholder ?? "Select...";
							return <Translate>{displayLabel}</Translate>;
									}}
								</SelectValue>
								<SelectArrow />
							</SelectTrigger>
							<SelectPopover>
								{options.map((opt) => (
									<SelectItem key={opt.value} value={opt.value}>
										<Translate>{opt.label}</Translate>
									</SelectItem>
								))}
							</SelectPopover>
						</SelectRoot>
					</div>
				)}
			/>
		);
	}

	if ("value" in props && "onChange" in props) {
		const { value, onChange, label, options, placeholder } = props;

		return (
			<div className={styles.root}>
				<SelectRoot
					value={value}
					setValue={(val) => {
						const selected = Array.isArray(val) ? val[0] : val;
						onChange(selected);
					}}
				>
					<SelectLabel>{label}</SelectLabel>
					<SelectTrigger>
						<SelectValue>
							{(v) => {
								const selected = options.find((o) => o.value === v);
								const displayLabel = selected?.label ?? placeholder ?? "Select...";
							return <Translate>{displayLabel}</Translate>;
							}}
						</SelectValue>
						<SelectArrow />
					</SelectTrigger>
					<SelectPopover>
						{options.map((opt) => (
							<SelectItem key={opt.value} value={opt.value}>
								<Translate>{opt.label}</Translate>
							</SelectItem>
						))}
					</SelectPopover>
				</SelectRoot>
			</div>
		);
	}
};
